import { render, staticRenderFns } from "./WorkDetail14.vue?vue&type=template&id=56f169e6&scoped=true&"
import script from "./WorkDetail14.vue?vue&type=script&lang=js&"
export * from "./WorkDetail14.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail14.vue?vue&type=style&index=0&id=56f169e6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f169e6",
  null
  
)

export default component.exports